import { LOADING_STATUS } from "@quest-finance/quest-fe-shared/dist/common/constants/loadingStatuses";
import { DocumentListState } from "../types/AssessmentDocument";

export const ASSESSMENT_DOCUMENT_DEFAULT_STATE: DocumentListState = {
  documents: [],
  count: 0,
  status: LOADING_STATUS.IDLE,
};
